const fontBold = {
    fontWeight: 'bold',
    borderTop: '1px solid #ccc'
}

const backTR = {
    backgroundColor: '#008800',
    color: '#fff',
}

const TabelaResumo = ({formatMoney, resumo}) => {
    if (!resumo) {
        return null;
    }

    return (
        <div className="borderTable" style={{marginTop: '20px'}}>
            <table className="table table_banca">
                <tr style={{backgroundColor: '#008800', color: '#fff'}}>
                    <th className="titulo" colSpan='7' style={{backgroundColor: '#008800', color: '#fff'}}>TOTAL GERAL DA BANCA</th>
                </tr>
                <tr style={backTR}>
                    <td style={fontBold}>Qtd.</td>
                    <td style={fontBold}>Entrada</td>
                    <td style={fontBold}>Saida</td>
                    <td style={fontBold}>Comissões</td>
                    <td style={fontBold}>Lançamentos</td>
                    <td style={fontBold}>Saldo Cambista</td>
                    <td style={fontBold}>Saldo Banca</td>
                </tr>

                <tbody>
                <tr style={{ fontWeight: 'bold' }}>
                    <td>{resumo.apostas}</td>
                    <td>{formatMoney(resumo.entrada)}</td>
                    <td>{formatMoney(resumo.saida)}</td>
                    <td>{formatMoney(resumo.comissoes)}</td>
                    <td>{formatMoney(resumo.lancamento)}</td>
                    <td 
                    className={`${resumo.total_cambista > 0 ? 'text-success' : ''} ${
                                resumo.total_cambista < 0 ? 'text-danger' : ''
                            }`}
                            >{formatMoney(resumo.total_cambista)}</td>
                    <td>
                        <b
                            className={`${resumo.total_banca > 0 ? 'text-success' : ''} ${
                                resumo.total_banca < 0 ? 'text-danger' : ''
                            }`}
                        >
                            {formatMoney(resumo.total_banca)}
                        </b>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};

export default TabelaResumo;
